module.exports = __webpack_public_path__ + "img/bmac.029ffd1e.png";